import Map from "./Map.js";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";
import { List } from "react-bootstrap-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { setSelectStaffPopup } from "../store/api/Modals";
import ModalSelectStaff from "../Components/ModalSelectStaff";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { addNewCustomer, editCustomerInfo, getCustomerBaseInfoes, getCutomerByID, getLastCustomerCode } from "../store/api/CustomerApi";
import { getAllProvinces, getCityList, getZoneList } from "../store/api/LocationAPI";

const AddEditCustomer = () => {
    const { id } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const locationCmbClicked = useRef(false);
    const settingNames = ['NationalCodeIsRequired'];
    const [isPending, setPending] = useState(false);
    const [customerType, setCustomerType] = useState('');
    const { register, handleSubmit, errors } = useForm();
    const [selectedAgency, selectAgency] = useState(null);
    const [customerCode, getCustomerCode] = useState(null);
    const [isMainCoChecked, setMainCoChecked] = useState(null);
    const [selectedMiddleman, selectMiddleman] = useState(null);
    const settings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const nationalCodeIsRequired = settings && Array.isArray(settings) && settings.find(s => s.SettingName === "NationalCodeIsRequired")?.SettingValue.toLowerCase() === "true";
    const { customer, baseInfoes } = useSelector(state => { return { customer: state.customerDataReducer.currentCustomer, baseInfoes: state.customerDataReducer.customerBaseInfoes } });
    const { provinceList, cityList, zoneList, currentLocation } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            currentLocation: state.locationDataReducer.currentLocation
        }
    });
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProvinces());
        dispatch(getCustomerBaseInfoes());
        if (Number(id) > 0) {
            dispatch(getCutomerByID(id));
        }
        else {
            dispatch(getLastCustomerCode(getCustomerCode));
        }
    }, [])
    const onProvinceChanged = (provinceID) => {
        locationCmbClicked.current = true;
        dispatch(getCityList(provinceID));
        dispatch(getZoneList());
    }
    const onCityChanged = (cityID) => {
        locationCmbClicked.current = true;
        dispatch(getZoneList(cityID));
    }
    const checkNationalCode = (Name) => {
        if (customerType === 'حقوقی') {
            return true;
        }
        if (Name.length === 10) {
            if (Name === '1111111111' ||
                Name === '0000000000' ||
                Name === '2222222222' ||
                Name === '3333333333' ||
                Name === '4444444444' ||
                Name === '5555555555' ||
                Name === '6666666666' ||
                Name === '7777777777' ||
                Name === '8888888888' ||
                Name === '9999999999') {
                return false;
            }
            let c = parseInt(Name.charAt(9));
            let n = parseInt(Name.charAt(0)) * 10 +
                parseInt(Name.charAt(1)) * 9 +
                parseInt(Name.charAt(2)) * 8 +
                parseInt(Name.charAt(3)) * 7 +
                parseInt(Name.charAt(4)) * 6 +
                parseInt(Name.charAt(5)) * 5 +
                parseInt(Name.charAt(6)) * 4 +
                parseInt(Name.charAt(7)) * 3 +
                parseInt(Name.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (Name === '') {
            return !nationalCodeIsRequired;
        }
        else {
            return false;
        }

    }
    const showSelectStaff = () => {
        dispatch(setSelectStaffPopup({ show: true, forAgency: true, forMiddleman: false, onSelect: selectAgency }));
    }
    const showMiddlemanPop = () => {
        dispatch(setSelectStaffPopup({ show: true, forAgency: false, forMiddleman: true, onSelect: selectMiddleman }));
    }
    const onMainChecked = (value) => {
        setMainCoChecked(value);
    }
    const onSubmit = (data) => {
        data.Latitude = currentLocation?.lat;
        data.Longtitude = currentLocation?.lng;
        if (selectedMiddleman !== null) {
            data.MiddleManCat = selectMiddleman.Cat;
        }
        if (Number(id) > 0) {
            const onSuccess = () => {
                setPending(false);
            }
            data.ID = Number(id);
            setPending(true);
            dispatch(editCustomerInfo(data, onSuccess))
        }
        else {
            const onSuccess = (result) => {
                setPending(false);
                history.replace("/BaseInfo/AddEditCustomer/" + result.ID);
            }
            setPending(true);
            dispatch(addNewCustomer(data, onSuccess));
        }
    }
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">اطلاعات مشتری</div>
                <div className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectStaff />
                    <input type="hidden" value={id} />
                    {customer === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                        </div>}
                    {customer !== "PENDING" &&
                        <form onSubmit={handleSubmit(onSubmit)} readOnly>
                            <div className="row">
                                <div className="form-group col-md-3">
                                    <label>عنوان احترام</label>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {baseInfoes?.RespectTitleList && Array.isArray(baseInfoes.RespectTitleList) &&
                                        <select className="form-control" name="RespectTitle" ref={register({})}
                                            defaultValue={customer?.RespectTitle ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {baseInfoes.RespectTitleList.map((item, i) => <option key={i} value={item.Item2}>{item.Item2}</option>)}
                                        </select>
                                    }
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>نام و نام خانوادگی</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <input type="text" className="form-control" name="Name" ref={register({ required: true })}
                                        defaultValue={ customer?.Name ?? ""} />
                                    {errors.Name && <small className="errors"> نام را وارد کنید </small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>{customerType === 'حقوقی' && 'شناسه ملی'}{customerType !== 'حقوقی' && 'کد ملی'}</label>{nationalCodeIsRequired && <span style={{ color: "red" }}>*</span>}
                                    <input type="text" className="form-control" name="NationalCode" ref={register({ validate: checkNationalCode })}
                                        defaultValue={customer?.NationalCode ?? ""} />
                                    {errors.NationalCode && <small className="errors"> کد ملی را وارد نشده است/معتبر نیست </small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد حساب</label>
                                    <input type="text" className="form-control" name="Code" readOnly
                                        value={customerCode !== null ? customerCode :  customer?.Code ??""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد اقتصادی</label>
                                    <input type="text" className="form-control" name="ComercialCode" ref={register({})}
                                        defaultValue={ customer?.ComercialCode ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد اشتراک</label>
                                    <input type="text" className="form-control" name="SubscriptionCode" ref={register({})}
                                        defaultValue={ customer?.SubscriptionCode ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد گذرنامه</label>
                                    <input type="text" className="form-control" name="PasportCode" ref={register({})}
                                        defaultValue={ customer?.PasportCode ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>رسته شغلی</label>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                        <select className="form-control" name="Job" ref={register({})}
                                            defaultValue={customer?.Job ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {baseInfoes.JobList.map((item, i) => <option key={i} value={item.Job}>{item.Job}</option>)}
                                        </select>
                                    }
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>گروهبندی</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {baseInfoes?.GroupList && Array.isArray(baseInfoes.GroupList) &&
                                        <select className="form-control" name="CustomerGroupID" ref={register({ required: true })}
                                            defaultValue={customer?.CustomerGroupID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {baseInfoes.GroupList.map((item, i) => <option key={i} value={item.ID}>{item.Group}</option>)}
                                        </select>
                                    }
                                    {errors.CustomerGroupID && <small className="errors"> انتخاب گروهبندی الزامی است</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>نوع مشتری</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <select className="form-control" name="Type" ref={register({ required: true })}
                                        defaultValue={ customer?.Type ?? ""} onChange={e => setCustomerType(e.target.value)}>
                                        <option key={-1} value=''>انتخاب کنید</option>
                                        <option key={0} value='حقوقی'>حقوقی </option>
                                        <option key={1} value='مرد'>مرد</option>
                                        <option key={2} value='زن'>زن </option>
                                    </select>
                                    {errors.Type && <small className="errors"> انتخاب نوع مشتری الزامی است</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>ماهیت حساب مشتری</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <select className="form-control" name="CustomerAccountType" ref={register({ required: true })}
                                        defaultValue={customer?.CustomerAccountType ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        <option value={true}>بدهکار </option>
                                        <option value={false}>بستانکار </option>
                                    </select>
                                    {errors.CustomerAccountType && <small className="errors"> انتخاب ماهیت مشتری الزامی است</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>وضعیت مشتری</label>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                        <select className="form-control" name="CustomerStatusID" ref={register({})}
                                            defaultValue={ customer?.CustomerStatusID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                        </select>
                                    }
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>تلفن</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <input type="text" className="form-control" name="Phone" ref={register({ required: true })}
                                        defaultValue={ customer?.Phone ?? ""} />
                                    {errors.Phone && <small className="errors"> تلفن مشتری را وارد کنید</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>موبایل</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <input type="text" className="form-control" name="Mobile" ref={register({ required: true })}
                                        defaultValue={customer?.Mobile ?? ""} />
                                    {errors.CustomerAccountType && <small className="errors"> موبایل مشتری را وارد کنید</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>دورنگار</label>
                                    <input type="text" className="form-control" name="Fax" ref={register({})}
                                        defaultValue={customer?.Fax ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>Email</label>
                                    <input type="text" className="form-control" name="Email" ref={register({})}
                                        defaultValue={customer?.Email ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>استان</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    {provinceList === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {provinceList && Array.isArray(provinceList) &&
                                        <select className="form-control" name="ProvinceID" ref={register({ required: true })}
                                            defaultValue={ customer?.ProvinceID ?? ""}
                                            onChange={e => onProvinceChanged(e.target.value)}>
                                            <option value="">انتخاب کنید</option>
                                            {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                        </select>
                                    }
                                    {errors.ProvinceID && <small className="errors"> انتخاب استان الزامی است</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>شهر</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    {cityList === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {cityList && Array.isArray(cityList) &&
                                        <select className="form-control" name="CityID" ref={register({ required: true })}
                                            onChange={e => onCityChanged(e.target.value)}
                                            defaultValue={customer?.CityID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {locationCmbClicked.current &&
                                                cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)
                                            }
                                            {!locationCmbClicked.current && customer && customer.CityID &&
                                                <option value={customer.CityID}>{customer.City}</option>
                                            }
                                        </select>}
                                    {errors.ProvinceID && <small className="errors"> انتخاب شهر الزامی است</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>منطقه</label>
                                    {zoneList === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {zoneList && Array.isArray(zoneList) &&
                                        <select className="form-control" name="ZoneID" ref={register({})}
                                            defaultValue={ customer?.ZoneID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {locationCmbClicked.current && zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                            {!locationCmbClicked.current && customer && customer.ZoneID &&
                                                <option value={customer.ZoneID}>{customer.Zone}</option>
                                            }
                                        </select>
                                    }
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد پستی</label>
                                    <input type="text" className="form-control" name="PostalCode" ref={register({})} defaultValue={customer && customer.PostalCode ? customer.PostalCode : ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>آدرس</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <input type="text" className="form-control" name="Address" ref={register({ required: true })}
                                        defaultValue={customer?.Address ?? ""} />
                                    {errors.Address && <small className="errors"> آدرس را وارد کنید</small>}
                                </div>
                                <div className="form-group col-md-3" >
                                    <label></label>
                                    <div style={{ border: "solid 1px #534082", borderRadius: "3px", padding: ".450rem .75rem", marginTop: "6px" }}>
                                        <input type="checkbox" className="form-check-input" name="IsMainCompany" ref={register({})} onChange={e => onMainChecked(e.target.checked)}
                                            defaultChecked={ customer?.IsMainCompany} />
                                        &nbsp;
                                        <label style={{ color: "blue" }}>شـرکت مــادر</label>
                                    </div>
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد اکتیو</label>
                                    <input type="text" className="form-control" name="ActiveCodeInMainCo" disabled={isMainCoChecked !== null ? !isMainCoChecked : false} ref={register({})}
                                        defaultValue={customer?.ActiveCodeInMainCo ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>کد نمایندگی</label>
                                    <input type="text" className="form-control" name="StaffCodeInMainCo" disabled={isMainCoChecked !== null ? !isMainCoChecked : false} ref={register({})}
                                        defaultValue={ customer?.StaffCodeInMainCo ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>نام نمایندگی</label>
                                    <input type="hidden" name="AgencyID" ref={register({})} readOnly value={selectedAgency ? selectedAgency.ID : customer && customer.AgencyID ? customer.AgencyID : ""} />
                                    <input type="text" className="form-control" style={{ width: "89%", display: "inline-block" }} readOnly
                                        value={selectedAgency ? selectedAgency.LastName :  customer?.AgentName?? ""} />
                                    <Button className="group-Btn-smalll" onClick={showSelectStaff}><List size={18} /></Button>
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>نام معرف</label>
                                    <input type="hidden" name="MiddleManID" ref={register({})} readOnly value={selectedMiddleman ? selectedMiddleman.ID : customer && customer.MiddleManID ? customer.MiddleManID : ""} />
                                    <input type="text" className="form-control" style={{ width: "89%", display: "inline-block" }} readOnly
                                        value={selectedMiddleman ? selectedMiddleman.LastName : customer?.MiddlemanName ?? ""} />
                                    <Button className="group-Btn-smalll" onClick={showMiddlemanPop}><List size={18} /></Button>
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>توضیحات</label>
                                    <input type="text" className="form-control" name="Description" ref={register({})}
                                        defaultValue={customer?.Description ?? ""} />
                                </div>
                                <div className="form-group col-md-3" >
                                    <label>متن اختصاصی پیامک تبریک تولد</label>
                                    <input type="text" className="form-control" name="HappyBirthdaySMSBody" ref={register({})}
                                        defaultValue={ customer?.HappyBirthdaySMSBody ?? ""} />
                                </div>
                                <Map location={{ lat: customer?.Latitude ?? 35.6996, lng: customer?.Longtitude ?? 51.3380, zoom: 9 }} />
                            </div>
                            <div>
                                <button className="btn btn-success btn-block  group-Btn">{isPending && <Loader type="BallTriangle" color="white" height={20} width={20} />} {!isPending && 'ثبت اطلاعات'}</button>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
    )
}
export default AddEditCustomer;